import React from "react";
import {
	Backdrop,
	Fade,
	Modal as MuiModal,
	ModalProps as MuiModalProps,
} from "@mui/material";
import {
	ModalButton,
	ModalButtonWrapper,
	ModalCancelButton,
	ModalTitle,
	ModalWrapper,
} from "@/components/Modal/style";

interface ModalProps extends MuiModalProps {
	handleClose: () => void;
	titleText: string;
	cancelButtonText?: string;
	submitButtonText?: string;
	disabledSubmitButton?: boolean;
	handleClickCancelButton?: () => void;
	handleClickSubmitButton?: () => void;
	disabledBackgroundClick?: boolean;
}

export default function Modal({
	children,
	open,
	handleClose,
	titleText,
	cancelButtonText,
	submitButtonText,
	disabledSubmitButton,
	handleClickCancelButton,
	handleClickSubmitButton,
	disabledBackgroundClick,
}: ModalProps) {
	const handleClickButton = () => {
		if (disabledSubmitButton) {
			return;
		}

		if (!handleClickSubmitButton) {
			return;
		}

		handleClickSubmitButton();
	};

	return (
		<MuiModal
			open={open}
			onClose={disabledBackgroundClick ? () => false : handleClose}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={open}>
				<ModalWrapper>
					<ModalTitle>{titleText}</ModalTitle>
					{children}
					<ModalButtonWrapper>
						{cancelButtonText && (
							<ModalCancelButton
								variant="contained"
								backgroundColor="#fff"
								disabledShadow
								onClick={handleClickCancelButton}
							>
								{cancelButtonText}
							</ModalCancelButton>
						)}
						{submitButtonText && (
							<ModalButton
								variant="contained"
								backgroundColor="#2453F9"
								disabledShadow
								disabled={disabledSubmitButton}
								onClick={handleClickButton}
							>
								{submitButtonText}
							</ModalButton>
						)}
					</ModalButtonWrapper>
				</ModalWrapper>
			</Fade>
		</MuiModal>
	);
}
